import api, { handleApiError } from './client';

export const commonService = {
  getCurrentAcademicYear: async () => {
    try {
      const response = await api.get('/api/common/academic-year/current');
      if (response.data !== undefined) {
        return { success: true, data: response.data };
      }
      return { success: false, message: "Errore nel recupero dell'anno sportivo corrente" };
    } catch (error) {
      console.error('Get current academic year error:', error);
      return handleApiError(error, "Errore nel recupero dell'anno sportivo corrente");
    }
  },

  getCurrentAcademicYearInfo: async () => {
    try {
      const response = await api.get('/api/common/academic-year/current-info');
      if (response.data) {
        return { success: true, data: response.data };
      }
      return { success: false, message: "Errore nel recupero delle informazioni dell'anno sportivo corrente" };
    } catch (error) {
      console.error('Get current academic year info error:', error);
      return handleApiError(error, "Errore nel recupero delle informazioni dell'anno sportivo corrente");
    }
  },
};

export default commonService;
